import { render, staticRenderFns } from "./IconDrop.vue?vue&type=template&id=a6f86948"
import script from "./IconDrop.vue?vue&type=script&lang=js"
export * from "./IconDrop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports